import React from "react";

const Article = () => {
  return (
    <div className="mb-20">
      <div>
        <h2 id="New parts">New parts</h2>
        <hr className="dividergeneral mb-5"></hr>
        <p>
          To pursue our project, we had to design several parts. First, we
          designed a new regulation system that need IPTG and theophylline
          simultaneously to prevent any leaking. Second, we modified the wild
          protein SpaC to make possible a transport by Lpp-Ompa.
        </p>
        <br></br> <br></br>
        <table style={{ fontFamily: "Tilda_sans", fontSize: "1.1em" }}>
          <tr>
            <th>Part</th>
            <th>ID</th>
            <th>Type</th>
            <th>Description</th>
            <th>Contribution</th>
          </tr>
          <tr>
            <td>Theophylline riboswitch</td>
            <td>
              <a href="http://parts.igem.org/Part:BBa_K4888000">BBa_K4888000</a>
            </td>
            <td>Basic part, regulatory DNA sequence</td>
            <td>
              Theophylline-responsive riboswitches, composed of an aptamer and a
              mandatory sequence
            </td>
            <td>Add the mandatory sequence</td>
          </tr>
          <tr>
            <td>IPTG+Theophylline double expression control system (+RBS)</td>
            <td>
              <a href="http://parts.igem.org/Part:BBa_K4888001">BBa_K4888001</a>
            </td>
            <td>Composite part</td>
            <td>
              Inducible regulatory system, to fuse upstream to the protein of
              interest. To produce the protein, both IPTG and theophylline must
              be present.
            </td>
            <td>We designed, tested and characterised this part.</td>
          </tr>
          <tr>
            <td>SpaC, mucus binding protein</td>
            <td>
              <a href="http://parts.igem.org/Part:BBa_K4888002">BBa_K4888002</a>
            </td>
            <td>Basic part, protein sequence</td>
            <td>Mucus binding protein</td>
            <td>Endogenous protein isolated from Lactobacillus</td>
          </tr>
          <tr>
            <td>SpaC, mucus binding protein, D2 domain</td>
            <td>
              <a href="http://parts.igem.org/Part:BBa_K4888003">BBa_K4888003</a>
            </td>
            <td>Basic part, protein sequence</td>
            <td>Mucus binding protein</td>
            <td>
              We isolated the D2 domain to shorten the proteins and tested it
            </td>
          </tr>
          <tr>
            <td>SpaC, mucus-binding protein, D2-D1 domains</td>
            <td>
              <a href="http://parts.igem.org/Part:BBa_K4888004">BBa_K4888004</a>
            </td>
            <td>Basic part, protein sequence</td>
            <td>Mucus binding protein</td>
            <td>
              We isolated the D2-D1 domains to shorten the proteins and tested
              it
            </td>
          </tr>
          <tr>
            <td>IPTG/Theophylline Lpp-OMpA D1/D2 SpaC</td>
            <td>
              <a href="http://parts.igem.org/Part:BBa_K4888005">BBa_K4888005</a>
            </td>
            <td>Composite part</td>
            <td>Mucus binding protein</td>
            <td>
              Express D1/D2 SpaC on the surface of E. coli on the constraint of
              a double induction system: IPTG and Theophylline dependant.
            </td>
          </tr>
          <tr>
            <td>IPTG/Theophylline Lpp-OMpA D2 SpaC</td>
            <td>
              <a href="http://parts.igem.org/Part:BBa_K4888006">BBa_K4888006</a>
            </td>
            <td>Composite part</td>
            <td>Mucus binding protein</td>
            <td>
              Express D2 SpaC on the surface of E. coli on the constraint of a
              double induction system: IPTG and Theophylline dependant.
            </td>
          </tr>
          <tr>
            <td>Constitutively expressed Lpp-OmpA EC20</td>
            <td>
              <a href="http://parts.igem.org/Part:BBa_K4888008">BBa_K4888008</a>
            </td>
            <td>Composite part</td>
            <td>Cadmium binding construct</td>
            <td>
              Express constitutively a cadmium binding protein on the surface of
              E.Coli
            </td>
          </tr>
        </table>
        <br></br> <br></br>
        <h2 className="mt-20" id="Used parts">
          Used parts
        </h2>
        <hr className="dividergeneral mb-5"></hr>
        <p className="mb-2">We used a number iGEM parts during the project.</p>
        <table style={{ fontFamily: "Tilda_sans", fontSize: "1.1em" }}>
          <tr>
            <th>Part</th>
            <th>ID</th>
            <th>Type</th>
            <th>Description</th>
            <th>Origin</th>
          </tr>
          <tr>
            <td>pLacI</td>
            <td>
              <a href="http://parts.igem.org/Part:BBa_K4179023">BBa_K4179023</a>
            </td>
            <td>Basic part, promoter</td>
            <td>Native promoter for LacI repressor from E. coli Lac operon.</td>
            <td>Technion-Israel, 2022</td>
          </tr>
          <tr>
            <td>LacI repressor from E. coli</td>
            <td>
              <a href="http://parts.igem.org/Part:BBa_K1088018">BBa_K1088018</a>
            </td>
            <td>Basic part, protein sequence</td>
            <td>Coding sequence for the LacI protein</td>
            <td>SDU-Denmark, 2013</td>
          </tr>
          <tr>
            <td>T7 promoter</td>
            <td>
              <a href="http://parts.igem.org/Part:BBa_K3633015">BBa_K3633015</a>
            </td>
            <td>Basic part, promoter</td>
            <td>Common promoter that can be induced by IPTG</td>
            <td>Shanghai_SFLS_SPBS, 2020</td>
          </tr>
          <tr>
            <td>Lac Operator</td>
            <td>
              <a href="http://parts.igem.org/Part:BBa_K2406019">BBa_K2406019</a>
            </td>
            <td>Basic part, operator</td>
            <td>Sequence that is bound by LacI repressor</td>
            <td>Edinburgh_UG, 2017</td>
          </tr>
          <tr>
            <td>Theophylline Riboswitch (Clone E)</td>
            <td>
              <a href="http://parts.igem.org/Part:BBa_K1212001">BBa_K1212001</a>
            </td>
            <td>Basic part, regulatory DNA sequence</td>
            <td>
              Encodes a RNA secondary structure that acts as a translational
              activator, riboswitch sensible to theophylline
            </td>
            <td>UC_Davis, 2013</td>
          </tr>
          <tr>
            <td>Constitutive promoter family member</td>
            <td>
              <a href="http://parts.igem.org/Part:BBa_J23100">BBa_J23100</a>
            </td>
            <td>Basic part, promoter</td>
            <td>Constitutive promoter for E.Coli</td>
            <td>Berkeley, 2006</td>
          </tr>
          <tr>
            <td>Lpp-OmpA-N</td>
            <td>
              <a href="http://parts.igem.org/Part:BBa_K1694002">BBa_K1694002</a>
            </td>
            <td>Basic part</td>
            <td>Expression system of outer membrane protein</td>
            <td>NCTU-Formosa, 2015</td>
          </tr>
          <tr>
            <td>Synthetic Phytochelatin EC(20) RFC[25]</td>
            <td>
              <a href="http://parts.igem.org/Part:BBa_K1321005">BBa_K1321005</a>
            </td>
            <td>Basic part, protein</td>
            <td>Heavy metal-binding synthetic phytochelatin EC20</td>
            <td>Imperial, 2014</td>
          </tr>
        </table>
        <br></br>
      </div>
    </div>
  );
};

export default Article;
